/***
 * @file:éªè¯è§åçæ­£åè¡¨è¾¾å¼
 * @author: linkun.he
 * @Date: 2019-06-03 10:11:13
 */
/** æ°å­ */
export const numberRe = /^((-?\d+\.\d+)|(-?\d+)|(-?\.\d+))$/;

/** å°æ° */
export const decimalFractionRe = /^(([^0][0-9]+|0)\.([0-9]{1,2}))$/;

/** èº«ä»½è¯ */
export const cardRe = /(^\d{15}$)|(^\d{17}([0-9]|X)$)/i;

/** ææºå· */
export const phoneRe = /^[1]([3-9])[0-9]{9}$/;
export const phoneReStrict = /^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/;

/** urlå°å */
export const adressRe = /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/;

/** email */
export const emailRe = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;

/** éé¶å¼å¤´çæå¤å¸¦ä¸¤ä½å°æ°çæ°å­ */
export const twoDecimalPlacesRe = /^([1-9][0-9]*)+(.[0-9]{1,2})?$/;

/** ä¸­æãè±æãæ°å­åæ¬ä¸åçº¿ï¼ */
export const languageNumberRe = /^[\u4E00-\u9FA5A-Za-z0-9_]+$/;

/** ä¸­æãè±æãæ°å­ä½ä¸åæ¬ä¸åçº¿ç­ç¬¦å· */
export const noLanguageNumberRe = /^[\u4E00-\u9FA5A-Za-z0-9]+$/;

/** è±æåæ°å­ï¼^[A-Za-z0-9]+$ æ ^[A-Za-z0-9]{4,40}$  */
export const figuresNumberRe = /^[A-Za-z0-9]+$/;

/** åå */
export const domainRe = /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/;

/** å½åçµè¯å·ç  */
export const teplphoneRe = /^(0\d{2,3}-\d{7,8})(-\d{1,4})?$/;

/**  ç­èº«ä»½è¯å·ç (æ°å­ãå­æ¯xç»å°¾)ï¼^([0-9]){7,18}(x|X)?$ æ ^\d{8,18}|[0-9x]{8,18}|[0-9X]{8,18}?$ */
export const shortIdCardRe = /^([0-9]){7,18}(x|X)?$/;

/** å¸å·æ¯å¦åæ³(å­æ¯å¼å¤´ï¼åè®¸5-16å­èï¼åè®¸å­æ¯æ°å­ä¸åçº¿)ï¼^[a-zA-Z][a-zA-Z0-9_]{4,15}$ */
export const legalityCountRe = /^[a-zA-Z][a-zA-Z0-9_]{4,15}$/;

/** å¼ºå¯ç (å¿é¡»åå«å¤§å°åå­æ¯åæ°å­çç»åï¼ä¸è½ä½¿ç¨ç¹æ®å­ç¬¦ï¼é¿åº¦å¨8-10ä¹é´)ï¼^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,10}$ */
export const pwdStrengthRe = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,10}$/;

/**  ç¹æ®å­ç¬¦ */
export const specialCharacterRe = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]Â·~ï¼@#ï¿¥%â¦â¦&*ï¼ï¼ââ\-+={}|ããï¼ï¼ââãããï¼ââï¼ãã]/im;

/** ä¸­å½é®æ¿ç¼ç ï¼[1-9]\d{5}(?!\d) (ä¸­å½é®æ¿ç¼ç ä¸º6ä½æ°å­) */
export const postalCodeRe = /[1-9]\d{5}(?!\d)/;

/** æåColor Hex  Codes\\#([a-fA-F]|[0-9]){3,6} */
export const ExtractionRe = /^#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})$/;

/** é¿åº¦ä¸º3-20çææå­ç¬¦ï¼^.{3,20}$ */
export const allCharacterRe = /^.{3,20}$/;

/**  m-nä½çæ°å­ï¼^\d{m,n}$ */
export const digitsNumberRe = /^\d{5,18}$/;

/** ä¸ºæ±å­ */
export const chineseRe = /^[\u4e00-\u9fa5]{0,}$/;

/** ç±26ä¸ªè±æå­æ¯ç»æçå­ç¬¦ä¸² */
export const alphabetRe = /^[A-Za-z]+$/;

/** è¾è®¯QQå·ï¼[1-9][0-9]{4,} */
export const tencentNumberRe = /^[1-9]\d{4,10}$/;

/** éªè¯æ°å­å¤§å°å¨15å°200ä¹é´ */
export const sizeNumberRe = /^1[6-9]$|^[2-9]\d$|^1\d{2}$/;

/** é¦å°¾ç©ºç½å­ç¬¦çæ­£åè¡¨è¾¾å¼ */
export const blankTrimRe = /^[^\s]*$/;

/** éªè¯è´§å¸å¯ä»¥å¸¦éå·æèä¸ºå¸¦åç¬¦å· */
export const commaNumberRe = /((^[-]?([1-9]\d*))|^0)(\.\d{1,2})?$|(^[-]0\.\d{1,2}$)|(^ï¿¥\d+(\.\d+)?$)|(^$\d+(\.\d+)?$)|(^\d+(\.\d+)?å$)|(^[-]?[1-9]((\d{0,2}$)|(\d{0,2}(\,\d{3})*$|((\d{0,2})(\,\d{3})*(\.\d{1,2}$)))))/;

/*
 * æ¥ææ ¼å¼éªè¯
 * å ä¸ºæ¥ææ ¼å¼æ¯è¾å¤ï¼ä¸»è¦éªè¯äºä»¥ä¸ç±»å
 * 1996-11-15
 */
export const dateLineRe = /((?!0000)[0-9]{4}-((0[1-9]|1[0-2])-(0[1-9]|1[0-9]|2[0-8])|(0[13-9]|1[0-2])-(29|30)|(0[13578]|1[02])-31)|([0-9]{2}(0[48]|[2468][048]|[13579][26])|(0[48]|[2468][048]|[13579][26])00)-02-29)/;

/*
 * ç½å
 * åªåè®¸httpãhttpsãftpè¿ä¸ç§
 * å¦ï¼http://www.baidu.com
 */
// export const webRe = /^(([hH][tT]{2}[pP][sS]?)|([fF][tT][pP]))\:\/\/[wW]{3}\.[\w-]+\.\w{2,4}(\/.*)?$/;
export const webRe = /^(?=^.{3,255}$)(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*$/;

/*
 * IPå°å
 * å¦ï¼192.168.1.102
 */
export const ipRe = /^((([1-9]\d?)|(1\d{2})|(2[0-4]\d)|(25[0-5]))\.){3}(([1-9]\d?)|(1\d{2})|(2[0-4]\d)|(25[0-5]))$/;
